// extracted by mini-css-extract-plugin
export default {"mainPage":"Main_mainPage__cT92H","title":"Main_title__jJnYZ","bookAds":"Main_bookAds__0xoco","bookAd":"Main_bookAd__W1FBC","bookAdCentered":"Main_bookAdCentered__MeWKG"};